<template>
    <div class="w-100 h-100">
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">Subject Photos</h2>
            <p class="tw-italic tw-text-gray-700">
                List subject photo URLs
            </p>
        </b-container>

        <b-container fluid class="tw-my-5">
            <b-row>
                <b-col cols="auto">
                    <b-form-datepicker
                        id="start_date"
                        v-model="start_date"
                        placeholder="Start Date"
                        class="mb-2"
                        reset-button
                    >
                    </b-form-datepicker>
                </b-col>
                <b-col cols="auto">
                    <b-form-datepicker
                        id="end_date"
                        :min="start_date"
                        :disabled="start_date == ''"
                        v-model="end_date"
                        placeholder="End Date"
                        class="mb-2"
                        reset-button
                    >
                    </b-form-datepicker>
                </b-col>
                <b-col cols="auto">
                    <b-form-input
                        v-model="subjectid"
                        placeholder="Enter Subject ID"

                    ></b-form-input>
                </b-col>
                <b-col cols="auto">
                    <b-button @click="$refs.resultTable.refresh();">Apply</b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-table
                    ref="resultTable"
                    striped
                    hover
                    :items="myProvider"
                    :fields="fields"
                    tbody-tr-class="vt-table-rows"
                >
                    <template #cell(picture_url)="data">
                        <b-link :href="data.value">{{data.value}}</b-link>
                    </template>
                </b-table>
            </b-row>
        </b-container>

        <hr />
    </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
// import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

// import * as _ from "lodash";

export default {
    mixins: [DashboardBaseTemplate],
    data() {
        return {
            response_data: '',
            start_date: '',
            end_date: '',
            subjectid: '',
            fields: [
              { key: 'subject_id', label: 'Subject', sortable: true, tdClass: 'table-cell-wide' },
              { key: 'enrollment_date', sortable: true, tdClass: 'table-cell-wide' },
              { key: 'picture_url', label: "URL", sortable: false, tdClass: 'table-cell' },
            ],
        };
    },
    computed: {},
    watch: {
        end_date: function() {
            this.$refs.resultTable.refresh();
        }
    },
    created() {},
    methods: {
        myProvider: async function (ctx) {
            const that = this;
            var params = new URLSearchParams();

            if(that.start_date && that.start_date != ''){
                params.append("start_date", that.start_date);
            }

            if(that.end_date && that.end_date != ''){
                params.append("end_date", that.end_date);
            }

            if(that.subjectid && that.subjectid != ''){
                params.append("subjectid", that.subjectid);
            }

            try {
                const response = await HTTP.get(`/srilanka/subject_photos`, {params: params});
                return response.data;
            } catch (error) {
                return [];
            }
        },
    },
};
</script>

<style>
.table-cell {
    margin: auto !important;
    padding: 3px !important;
    font-size: small !important;
}
.table-cell-wide {
    margin: auto !important;
    padding: 3px !important;
    font-size: small !important;
    min-width: 200px;
    max-width: 400px;
}
</style>